<template>
    <div class="indexContainer">
        <!-- 搜索框 -->
        <div class="goSearch" @click="goSearch">
            <input type="text" placeholder="请输入">
        </div>
        <!-- 轮播 -->
        <swipers />
        <!-- 导航 -->
        <navList />
        <!-- 最新上架 -->
        <newest @goBookInfo="goBookInfo" />
        <!-- 猜你喜欢 -->
        <isLike @goBookInfo="goBookInfo" />
        <!-- 热听 -->
        <hotlis @goBookInfo="goBookInfo" />
        <!-- 精选分类带前三 -->
        <themes @goBookInfo="goBookInfo" />
        
        <div class="banquan">
            <p>京ICP备11030783号-6 </p>
            <p>© 2019 北京云途经纬科技文化传媒有限公司</p>
        </div>
    </div>
</template>
<script>
import swipers from "./indexCom/swipers.vue";
import navList from "./indexCom/nav.vue";
import newest from "./indexCom/newest.vue";
import isLike from "./indexCom/isLike.vue";
import hotlis from "./indexCom/hotlis.vue";
import themes from "./indexCom/themes.vue";

import Swiper from "swiper";


export default {
    components: {
        swipers,
        navList,
        newest,
        isLike,
        hotlis,
        themes
    },
    data() {
        return {
            navList: [],
            errMsg: ''
        }
    },
    created() {
        var that = this;
        // that.getClassNav();
        if( localStorage.getItem("errMsg") ) {
            that.errMsg = localStorage.getItem("errMsg");
            let data = {
                msg: that.errMsg
            }
            that.$emit("dialogChange", data);
        }
    },
    methods: {
        goSearch() {
            this.$router.push("/search");
        },
        goBookInfo(id) {
            this.$router.push({ path: `/bookInfo/${id}` });
        },
        getClassNav() {
            var that = this;
            that.allApi.getClassNav("nav").then((resource)=>{
                // console.log(JSON.parse(resource.data))
                that.navList = JSON.parse(resource.data).t[0].classDtos;
                that.$nextTick(()=>{
                    that.navSwiper();
                })
            })
        },
        navSwiper() {
            new Swiper(".nav", {
                slidesPerView: "auto"
            });
        },
        goClassBookList(id) {
            this.$router.push({
                path: "/classBookList",
                query: {
                    childId: id,
                    idx: -1,
                    parentId: id
                }
            });
        },
    }
}
</script>
<style lang="scss">
@function rem($args) {
    $uiWidth: 75px;
    @return $args/$uiWidth*1rem;
}
.indexContainer{
    position: absolute;
    left: 0;
    width: 100%;
    bottom: rem(114px);
    top: 0;
    padding-top: rem(24px);
    background: #fff;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    
    .classNav{
        display: flex;
        >li{
            flex: 1;
            text-align: center;
            >img{
                display: block;
                width: rem(132px);
                height: rem(132px);
                margin: 0 auto;
            }
            >p{
                font-size: rem(24px);
                color: #666;
                line-height: rem(24px);
            }
        }
    }
    .goSearch{
        width: 100%;
        >input{
            display: block;
            width: rem(670px);
            height: rem(60px);
            margin: 0 auto rem(45px);
            line-height: rem(60px);
            padding: 0 rem(24px);
            color: #666;
            text-indent: rem(40px);
            background: url('../assets/imgs/index/search.png') rem(24px) center / rem(30px) rem(30px) no-repeat, #EAE9E9;
            border: 0;
            border-radius: rem(30px);
            outline: none;
            font-size: rem(24px);
        }
    }
    .banquan{
        width: rem(666px);
        font-size: rem(20px);
        color: rgb(102, 102, 102);
        text-align: center;
        margin: 0 auto;
        padding: rem(60px) 0;
        border-top: 1px solid #eee;
    }
}
</style>
